import { action } from 'satcheljs';
import { OwaDate } from 'owa-datetime';

/**
 * Action to get the latest events count for days around the pivot date or selected date.
 */
const refreshEventsCount = action(
    'refreshEventsCount',
    (pivotDate?: OwaDate, forceRefresh: boolean = false) => ({
        pivotDate,
        forceRefresh,
    })
);

export default refreshEventsCount;
